import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const Heading = styled.h3`
  text-align: center;
  overflow-x: hidden;
  font-weight: 500;
  margin: 30px 0 50px;
`;

export const Lines = styled.span`
  position: relative;

  &::before,
  &::after {
    content: '';
    width: 99999px;
    height: 2px;
    background: #DFE0E0;
    position: absolute;
    top: 50%;
  }

  &::before {
    right: 100%;
    margin-right: 25px;
  }

  &::after {
    left: 100%;
    margin-left: 25px;
  }
`;

export const Grid = styled.div`
  ${breakpoint('tablet')`
    margin-right: -20px;
  `}

  &::after {
    content: '';
    clear:both;
    display: block;
  }
`;

export const GridItem = styled.div`
  margin-bottom: 10px;
  width: 100%;

  ${breakpoint('tablet')`
    float: left;
    margin-bottom: 30px;
    padding-right: 20px;

    width: ${({count}) => count < 3 ? (100/count) : '33.3333'}%;
  `}
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
`;

export const CardWrapper = styled.div`
  position: relative;
`;

export const ContentWrapper = styled.div`
  position: absolute;
  bottom: 40px;
  left: 0;
  width: 100%;
  height: auto;
  text-shadow: 0 0 20px #000;
  text-align: center;
`;

export const StyledHeading = styled.h4`
  margin: 0;
  color: #fff;
  padding: 0 15px;
  font-weight: 400;
`;

export const StyledLink = styled.a`
  color: #fff;
  text-decoration: underline;
  font-weight: 400;

  &:visited, &:link {
    color: white;
    font-weight: 400;
    text-decoration: underline;
  }
`;

export const StyledDate = styled.span`
  color: #fff;
  font-weight: 400;
  text-transform: uppercase;
`;